export default {
    routes: {
        _public_api_get_quote_history: '/api/v1/quote-history/{id}/{checksum}',
        _public_api_quote_accept: '/api/v1/quote/accept/{id}/{checksum}',
        _public_api_quote_ask: '/api/v1/quote/ask/{id}/{checksum}',
        _public_api_quote_reject: '/api/v1/quote/reject/{id}/{checksum}',
        _public_api_options_base_data: '/api/v1/options/base-form-data',
        _public_api_options_turndown_options: '/api/v1/options/quote-turn-down-options/{usedBy}',
        _public_api_send_quote: '/api/v1/quote/{bandSlug}',
        _public_api_retrieve_password: '/api/v1/forgot-password/retrieve',
        _public_api_send_signup: '/api/v1/send-signup',
        _public_api_get_invitation: '/api/v1/invitation-details/{id}/{hash}',
        _public_signup_tos: '/{locale}/terms-and-conditions/{terms}/{country}/{language}',
        _public_api_flush_from_email_queue: '/api/v1/flush-from-email-queue',
        _public_api_gigs: '/api/v1/gigs/{bandSlug}',
        _public_api_gig_reviews: '/api/v1/gig-reviews/{bandSlug}',
        _public_api_send_feedback: '/api/v1/send-feedback',
        _public_api_send_gig_review: '/api/v1/send-gig-review/{id}/{hash}',
        _public_api_recommended_bands: '/api/v1/recommendations/bands',
        _public_api_download_quote_contract: '/api/v1/quote/{id}/{hash}/download-contract',
    },
    generate(route, paramsObject) {
        let baseRoute = this.getRoute(route);
        if (typeof paramsObject === 'object') {
            Object.keys(paramsObject).forEach((key) => {
                let urlVar = `{${key}}`;
                baseRoute = baseRoute.replace(urlVar, paramsObject[key]);
            });
        }
        return baseRoute;
    },
    getRoute(route) {
        if (this.routes[route]) {
            return this.routes[route];
        }
        throw new Error(`No route found for ${route}`);
    }
};
